"use strict";import{tag as a}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Chevron50Icon=({width:t=24,height:e=24,title:r="Chevron50"}={})=>a`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${t}
    height=${e}
    aria-hidden="true"
    role="img"
    fill="currentColor"
    aria-label=${r}
  >
    <path
      d="M1.985 5.961a.695.695 0 01-.7-.704.695.695 0 01.209-.493L3.279 3 1.51 1.251A.695.695 0 011.3.757.696.696 0 012.492.255l2.275 2.247a.7.7 0 010 .996L2.477 5.76a.697.697 0 01-.492.201z"
    />
  </svg>`;
//# sourceMappingURL=Chevron50.js.map
